<div class="ap-recipients-people">
    <div class="ap-recipients-header">
        <p class="ap-section-label">
            {{ section.label }}
            <span class="ap-recipients-count">· {{ selectionCount }} {{ selectionCount === 1 ? 'recipient' : 'recipients' }}</span>
        </p>
    </div>

    <div class="ap-recipients-note" *ngIf="section.note">
        <i class="ph-bold ph-info icon-primary icon-16" aria-hidden="true"></i>
        <span>{{ section.note }}</span>
    </div>

    <app-people-picker
        [preselectedPersonIds]="existingPersonIds"
        [allowFreeformEmail]="true"
        [maxSelections]="0"
        placeholder="Search people or type an email…"
        (selectionsChange)="onSelectionChange($event)">
    </app-people-picker>
</div>
